export default "__VITE_ASSET__tL6QnIbD__"